export const Brands = {
  MYSCHNEIDER: 'myschneider'
};